//third party

import { NgModule } from "@angular/core";
import { RegExValidatorDirective } from "./reg-ex/reg-ex.directive";
import { UrlValidatorDirective } from "./url/url.directive";








@NgModule({
  exports: [
    RegExValidatorDirective,
    UrlValidatorDirective
  ],
  declarations: [
    RegExValidatorDirective,
    UrlValidatorDirective
  ],
  imports: [
    
  ]
})
export class ValidatorsModule { }
